import { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { format } from 'date-fns';
import qs from 'qs';

import { SelectMultiAsync } from '@components/selectmulti';

import { api } from 'api';

import { useStore } from 'models/Provider';

import { debounce } from 'helpers';

export const ApplicationSearch = observer(({ jobId, label, onSelect, selected = [] }) => {
  const { t } = useStore();
  const [defaultOptions, setDefaultOptions] = useState([]);

  const searchApplications = useMemo(
    () =>
      debounce((searchStr, callback) => {
        let applications = [];
        const queryString = qs.stringify(
          {
            search_multi_match: searchStr || null,
            job: jobId,
            limit: 10,
            id__is_not: [selected.map((s) => s.value)],
          },
          { addQueryPrefix: true, skipNulls: true, encode: false, indices: false }
        );
        api.applications.search(queryString).then((data) => {
          if (data.results.length) {
            data.results.forEach((application) => {
              applications.push({
                label: application.name,
                value: application.id,
                helpText: format(new Date(application.date), 'yyyy / MMM / d'),
              });
            });
          }
          callback(applications);
        });
      }, 300),
    [jobId, selected]
  );

  useEffect(() => {
    searchApplications('', setDefaultOptions);
  }, [searchApplications]);

  return (
    <SelectMultiAsync
      placeholder={t('job.access.limitedaccess.modal.search')}
      label={label}
      defaultOptions={defaultOptions}
      loadOptions={searchApplications}
      defaultValue={selected}
      onChange={onSelect}
      loadingMessage={() => t('job.access.limitedaccess.modal.searching')}
      noOptions={({ inputValue }) => {
        if (inputValue !== '')
          return t('job.access.limitedaccess.modal.search.nomatch', inputValue);
        return t('job.access.limitedaccess.modal.search.noapplicants');
      }}
    />
  );
});
